import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type CalendarSurfaceStore from '../store/schema/CalendarSurfaceStore';

/**
 * Checks whether the given item is selected on surface
 * @param store The calendar surface store
 * @param item The surface item
 * @returns true if the item is selected, false otherwise
 */
export default function isItemSelected(store: CalendarSurfaceStore, item: CalendarEvent): boolean {
    return store.selectedItem && item && store.selectedItem.ItemId.Id == item.ItemId.Id;
}
